import { Pill, type PillVariant } from "@/components/podkit/status/Pill";
import { type FC, useMemo } from "react";

export type LabelPhase =
    | "unspecified"
    | "stopped"
    | "deleted"
    | "stopping"
    | "starting"
    | "running"
    | "failed"
    | "succeeded";

export type PhaseLabelProps = {
    phase: LabelPhase;
};

export const PhaseLabel: FC<PhaseLabelProps> = ({ phase }) => {
    const variant: { variant: PillVariant; label: string } | undefined = useMemo(() => {
        switch (phase) {
            case "unspecified":
                return {
                    label: "Unspecified",
                    variant: "neutral",
                };
            case "stopped":
                return {
                    label: "Stopped",
                    variant: "neutral",
                };
            case "deleted":
                return {
                    label: "Deleted",
                    variant: "neutral",
                };
            case "stopping":
                return {
                    label: "Stopping",
                    variant: "warning",
                };
            case "starting":
                return {
                    label: "Starting",
                    variant: "warning",
                };
            case "running":
                return {
                    label: "Running",
                    variant: "success",
                };
            case "failed":
                return {
                    label: "Failed",
                    variant: "danger",
                };
            case "succeeded":
                return {
                    label: "Succeeded",
                    variant: "success",
                };
        }
    }, [phase]);

    if (!variant) {
        return null;
    }

    return (
        <Pill size="md" variant={variant.variant}>
            {variant.label}
        </Pill>
    );
};
